module.exports = __webpack_public_path__ + "static/media/3.f75f04af.webp";